import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/siteInfo";

export default function HeroCarousel() {
  const slides = siteInfo.carousel;
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const goTo = (i: number) => setIndex((i + slides.length) % slides.length);
  const active = slides[index];

  return (
    <section className="relative w-full overflow-hidden bg-primary-950">
      <div className="relative h-[440px] w-full md:h-[600px]">
        {slides.map((slide, i) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              i === index ? "opacity-100" : "opacity-0"
            }`}
          >
            <img
              src={slide.image}
              alt={`《年轻的母亲2》${slide.title} 剧照`}
              title={`${slide.title} - 年轻的母亲2 剧情介绍`}
              className="h-full w-full object-top"
            />
          </div>
        ))}
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/95 via-primary-950/60 to-primary-950/40"></div>

        <div className="relative z-10 mx-auto flex h-full w-full flex-col justify-end px-4 pb-16 md:px-6 md:pb-20">
          <div className="max-w-2xl animate-fade-up" key={active.id}>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-3 py-1 font-label text-xs font-semibold text-primary-950">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-fire-line text-sm"></i>
              </span>
              本季热播
            </span>
            <p className="mt-4 font-label text-sm text-background-300">{active.subtitle}</p>
            <h1 className="mt-2 font-heading text-3xl font-extrabold leading-tight tracking-tight text-background-50 md:text-5xl">
              {active.title}
            </h1>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
              {active.desc}
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <Link
                to={`/episode/${active.id}`}
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-3 font-label text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-400"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-book-open-line text-base"></i>
                </span>
                查看本集剧情
              </Link>
              <Link
                to="/episodes"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-100/40 bg-background-50/10 px-5 py-3 font-label text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
              >
                全部剧集
              </Link>
            </div>
          </div>
        </div>

        <div className="absolute bottom-6 right-4 z-10 flex items-center gap-2 md:right-6">
          <button
            type="button"
            aria-label="上一张"
            onClick={() => goTo(index - 1)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-background-100/30 bg-primary-950/40 text-background-50 backdrop-blur transition-colors hover:bg-primary-950/70"
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>
          <button
            type="button"
            aria-label="下一张"
            onClick={() => goTo(index + 1)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-background-100/30 bg-primary-950/40 text-background-50 backdrop-blur transition-colors hover:bg-primary-950/70"
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>
        </div>

        <div className="absolute bottom-7 left-4 z-10 flex items-center gap-2 md:left-6">
          {slides.map((slide, i) => (
            <button
              key={slide.id}
              type="button"
              aria-label={`切换到第${i + 1}张`}
              onClick={() => goTo(i)}
              className={`h-1.5 cursor-pointer rounded-full transition-all ${
                i === index ? "w-8 bg-accent-500" : "w-3 bg-background-100/50 hover:bg-background-100/80"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}